import React from 'react';
import {projectsText} from '../projectsText';
import styles from './ProjectContentToggle.module.css';

export type ProjectTab = 'courses' | 'microreels' | 'posts';

const TABS: {key: ProjectTab; label: string}[] = [
  {key: 'courses', label: projectsText.courses},
  {key: 'microreels', label: projectsText.microreels},
  {key: 'posts', label: projectsText.posts},
];

interface Props {
  tab: ProjectTab;
  onChange: (tab: ProjectTab) => void;
}

const ProjectContentToggle = React.memo(({tab, onChange}: Props) => (
  <div className={styles.toggle} role="tablist">
    {TABS.map(item => (
      <button
        key={item.key}
        type="button"
        role="tab"
        aria-selected={tab === item.key}
        className={`${styles.option} ${
          tab === item.key ? styles.optionActive : ''
        }`}
        onClick={() => onChange(item.key)}>
        {item.label}
      </button>
    ))}
  </div>
));

export default ProjectContentToggle;
